import React from 'react';

export const CITY = 'CITY';
export const DENTAL = 'DENTAL';
export const FACILITY = 'HBP';
export const FACILITY_TYPE = 'FACILITYNEW';
export const MEDICAL = 'MEDICAL';
export const NETWORK_MAP = 'NETWORKMAP';
export const NETWORK_NAME = 'NETWORK';
export const NETWORK_TYPE = 'NETWORK_TYPE';
export const PHARMACY = 'PHARMACY';
export const RADIUS = 'RADIUS';
export const STATE = 'STATE';
export const SPECIALITY = 'SPECIALTY';
export const SPECIALITY_TYPE = 'SPECIALTYNEW';
export const VISION = 'VISION';

// HEADERS
export const HEADERS = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
};
// METHODS
export const POST = 'POST';
export const GET = 'GET';

export const networkTypeList = {
    Medical: '1',
    Dental: '2',
    Vision: '4',
    Pharmacy: '3'
};

export const genderType = {
    Male: 'M',
    Female: 'F'
};

// 400 Bad Request
// 404 Not Found
export const errorMsg = (err) => {
    let msg = '';
    if (err.includes('400')) {
        msg = 'Bad Request. Please select appropriate options';
    }
    if (err.includes('404')) {
        msg = 'Not Found. Please try later';
    }
    return msg;
};

export const facilityRdoc = (e) => {
    if (e === 'D') {
        return 'D';
    }
    if (e === 'F') {
        return 'F';
    }
    return 'A';
};

export const formatPhoneNumber = (n) => {
    const phn = /\(?\b\d{3}\)[. ]?\d{3}[-. ]?\d{4}\b/gm;

    if (!phn.test(n)) {
        if (n.length === 10) {
            return n.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        } else if (n.length > 0) {
            const cleaned = n.replace(/\D+/g, '');
            const formatted = cleaned.replace(/^0+/, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
            return formatted;
        } else {
            return null;
        }
    }

    return n;
};


// Facility Details getHBP Accordion keys
export const getFacilityName = {
    Anesthesiologist_Assistants: 'Anesthesiologist Assistant',
    Anesthesiologists: 'Anesthesiologist',
    Emergency_Department_Physicians: 'Emergency Department Physician',
    Neonatologists: 'Neonatologist',
    Nurse_Anesthetists: 'Nurse Anesthetist',
    Nurse_Midwifes: 'Nurse Midwife',
    Occupational_Therapists: 'Occupational Therapist',
    Pathologists: 'Pathologist',
    Physical_Therapists: 'Physical Therapist',
    Radiologists: 'Radiologist',
    SpeechLanguage_Pathologists: 'Speech-Language Pathologist',
    Surgical_Assistants: 'Surgical Assistant'
};

export const getLastNameORFacility = (e) => {
    if (e.lastName === '') {
        return e.facilityName;
    }
    return `${e.firstName} ${e.lastName}`;
};

export const getLastNameORProvider = (e) => {
    if (e.lastName === '') {
        return e.facilityName;
    }
    const degree = e.providerDegree ? `, ${e.providerDegree}` : '';
    return `${e.firstName} ${e.lastName}${degree}`;
};

export const getAddress = (e) => {
    let res = '';
    const fres = (
        <>
            <div className="info-data">
                {e.facilityName}
                <br />
                {e.addressLine1}
                <br />
                {e.addressLine2 ? (
                    <>
                        {e.addressLine2}
                        <br />
                    </>
                ) : <span />}
                {e.city}
                {', '}
                {e.state}
                {', '}
                {e.zipCode}
            </div>
        </>
    );
    const ares = (
        <>
            <div className="info-data">
                {e.addressLine1}
                <br />
                {e.addressLine2 ? (
                    <>
                        {e.addressLine2}
                        <br />
                    </>
                ) : <span />}
                {e.city}
                {', '}
                {e.state}
                {', '}
                {e.zipCode}
            </div>
        </>
    );
    if (e.facilityName === '') {
        res = ares;
    } else {
        res = fres;
    }
    return res;
};

export const getMoreLocations = (e, style) => {
    const res = (
        <>
            <div className={style}>
                {e.serviceLocationLine1}
                <br />
                {e.serviceLocationLine2 ? (
                    <>
                        {e.serviceLocationLine2}
                        <br />
                    </>
                ) : <span />}
                {e.serviceLocationCity}
                {', '}
                {e.serviceLocationState}
                {', '}
                {e.serviceLocationZipCode}
                {' '}
            </div>
        </>
    );
    return res;
};

export const getLanguageSpoken = (l) => {
    if (l) {
        return `, ${l}`;
    }
    return '';
};

export const getHospitalAffiliation = (l) => {
    if (l) {
        return (
            <div>
                <span>,</span>
                <br />
                {l}
            </div>
        );
    }
    return '';
};

export const getLocalStorage = (key) => localStorage.getItem(key);

export const setLocalStorage = (key, value) => localStorage.setItem(key, value);

export const removeLocalStorage = (key) => localStorage.removeItem(key);

export const clearLocalStorage = () => localStorage.clear();

export const clearLocalStorageData = () => {
    const ahbFaclty = /ahb_fclty_*[0-9]+/gm;
    const ahbPrvd = /ahb_prvd_*[0-9]+/gm;
    const network = /slctd_network/gm;
    const keys = Object.keys(localStorage);
    keys.forEach((i) => {
        if (!ahbFaclty.test(i) || !ahbPrvd.test(i) || !network.test(i)) {
            removeLocalStorage(i);
        }
    });
};

export const checkAddress = (prvd, mrlc) => {
    const res = [];
    mrlc.forEach((i) => {
        if (prvd.addressLine1 !== i.serviceLocationLine1) {
            res.push(i);
        }
    });
    return res;
};

export const getSpcltyType = (provider, specialtytype) => {
    if (provider.specialtyCode !== undefined) {
        let res = provider.specialtyCode;
        specialtytype.filter((i) => {
            if (i.specialtyCode === provider.specialtyCode) {
                res = i.specialtyDesc;
            }
            return res;
        });
        return res;
    }
    return provider.specialtyDesc;
};

export const returnNoData = (data, status, fcltysplty) => {
    if (data.length === 0 && !status && fcltysplty !== '') {
        return 'No Data Found';
    }
    if (data.length === 0 && status && fcltysplty !== '') {
        return 'Loading...';
    }
    return <span />;
};

export const getName = (n) => {
    let res;
    if (n === 'F') {
        res = 'Facility Type';
    } else if (n === 'D') {
        res = 'Specialty Type';
    } else {
        res = '';
    }
    return res;
};

export const getSpecialtyFacilityType = (provider, sorf, type) => {
    if (type === 'facility') {
        const facilityCode = provider && provider.facilityCode;
        const desc = facilityCode !== undefined
          ? sorf.find((i) => i.facilityCode === facilityCode) : undefined;
        const facilityDesc = desc ? desc.facilityDesc : provider.facilityDesc;
        return facilityDesc || '';
    }
    if (type === 'specialty') {
        const specialtyCode = provider && provider.specialtyCode;
        const desc = specialtyCode !== undefined
          ? sorf.find((i) => i.specialtyCode === specialtyCode) : undefined;
        const specialtyDesc = desc ? desc.specialtyDesc : provider.specialtyDesc;
        return specialtyDesc || '';
    }
    return '';
};

// ***** IMPORTANT *****
// sourcetypeid which is networkId from referencedata/network API
// networkid which is dataTypeId from referencedata/network API

// handleProviderType -> setProvidrType -> providerType
// handleNetworkDrop -> setNetwork -> network
// handleCityZip, handleKeyWord -> setZipSelected -> zipSelected
// handleCityZip, **handleKeyWord, handleSelectBy -> setKeyword -> searchKeyword
